<template>
    <article>
        <div class="card">
            <button
                v-if="isLoggedIn"
                :data-id="product.id"
                :class="[
                    { 'is-favorited': product.isFavorited },
                    'card-favorite animation-confetti js-product-favorite'
                ]"
                aria-label="Favorite"
            >
                <star-icon />
            </button>

            <div class="card-inner h-100 d-flex flex-column">
                <figure class="card-figure card-figure-product">
                    <img
                        v-if="product.image_uid"
                        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                        :data-src="responsiveImagesLast"
                        :data-srcset="responsiveImages"
                        data-sizes="auto"
                        class="image-responsive lazyload lazyload-animate"
                        :alt="product.title"
                    >
                </figure>

                <!-- Card content -->
                <div class="card-content">
                    <div class="card-content-header d-flex justify-content-between" style="margin-bottom: 8px;">
                        <!-- Subtitle -->
                        <div>
                            <p v-if="product.subtitle" class="card-subtitle">
                                {{ product.subtitle }}
                            </p>
                        </div>

                        <!-- Price -->
                        <div class="price price-large d-flex flex-column align-items-end" style="width: 100px;">
                            <!-- Default price -->
                            <span v-if="isBusinessUser">
                                {{ product.priceExc.amount | currency }}
                            </span>
                            <span v-else>
                                {{ product.price.amount | currency }}
                            </span>

                            <!-- Old price -->
                            <span v-if="product.price.old" class="price-old">
                                <span v-if="isBusinessUser">
                                    {{ product.priceExc.old | currency }}
                                </span>
                                <span v-else>
                                    {{ product.price.old | currency }}
                                </span>
                            </span>
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="card-content-body">
                        <p class="card-title">{{ product.title }}</p>
                    </div>
                </div>

                <div class="card-overlay d-flex flex-column align-items-center justify-content-center">
                    <button
                        @click="addToBasket"
                        ref="addToBasket"
                        :class="[
                            {
                            	'is-loading': isLoading,
                            	'btn-primary': product.inStock,
                            	'btn-secondary': !product.inStock,
                            	'prevent-clicks': !product.inStock && !isBusinessUser,
                            },
                            'btn'
                        ]"
                    >
                        <span
                            ref="addToBasketText"
                            class="text-center"
                        >
                            <template v-if="product.inStock">
                                {{ $t('product.add_to_basket') }}
                            </template>
                            <template v-else-if="isBusinessUser">
                                {{ $t('product.not_in_stock_on_request') }}
                            </template>
                            <template v-else>
                                {{ $t('product.not_in_stock') }}
                            </template>
                        </span>

                        <span ref="addToBasketSuccess" class="product-button-success sr-only">
                            <div v-if="product.inStock === false && !isBusinessUser">
                                {{ $t('product.not_in_stock') }}
                            </div>
                            <div v-else>
                                <i data-feather="check-circle"></i>
                                {{ $t('product.add_to_basket_added') }}
                            </div>
                        </span>
                    </button>

                    <a :href="product.url" class="text-white mt-4">
                        {{ $t('product.more_information') }}
                    </a>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    import axios from 'axios';
    import cdn from '@23g/cdn-helper';
    import sleep from '@/_vue/helpers/sleep';
    import { StarIcon } from 'vue-feather-icons';

    export default {
        name: 'ProductCard',
        components: {
            StarIcon,
        },
        data() {
            return {
                imageWidths: [
                    'h360',
                    'h720',
                ],
                isLoading: false,
            };
        },
        props: {
            product: {
                required: true,
            },
        },
        computed: {
            responsiveImagesLast() {
                return cdn(this.product.image_uid, 'h720');
            },

            responsiveImages() {
                return this.generateImageSizes(this.product.image_uid, this.imageWidths);
            },
        },
        methods: {
            async addToBasket() {
                this.isLoading = true;
                const { data } = await axios.post(this.route('cart.store'), {
                    amount: this.product.minimumOrderQuantity || 1,
                    in_stock: this.product.inStock,
                    variant_id: this.product.id,
                })
                    .finally(async () => {
                        await sleep(1000);
                        this.isLoading = false;
                    });

                await sleep(500);

                const totalItems = (data.basket_count > 99) ? '99+' : data.basket_count;
                this.isLoading = false;
                this.$emit('addedToCart');
                this.$refs.addToBasket.classList.add('success');
                this.$refs.addToBasketText.classList.add('sr-only');
                this.$refs.addToBasketSuccess.classList.remove('sr-only');
                this.$root.$refs.basketCount.innerText = totalItems;

                await sleep(1000);
                this.$refs.addToBasket.classList.remove('sr-only');
                this.$refs.addToBasketText.classList.remove('sr-only');
                this.$refs.addToBasketSuccess.classList.add('sr-only');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .card-favorite {
        top: 0;
        right: 0;
    }
</style>
